import React, { Fragment, ReactNode, useState } from 'react';
import * as ReactDOM from 'react-dom';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { addYears, format, getWeek, parse } from 'date-fns';
import { useMediaQuery } from 'react-responsive'
import './App.css';
import { createRoot } from 'react-dom/client';
import ja from "date-fns/locale/ja";


const queryClient = new QueryClient();

type CalendarEventTime = {
  time:string
}

type CalendarEventCancel = {
  target_date: string,
  time: string
}
type Term = {
  name:string,
  slug:string,
  taxonomy:string
}
type CalendarEvent = {
  url: string,
  event_class: string | undefined | null,
  time: CalendarEventTime[],
  start_date: string | Date,
  end_date: string | Date,
  title: string,
  isCanceled: boolean | undefined,
  cancel: CalendarEventCancel[],
  terms: Term[]
}

const ClockIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="12.2" height="12.2" viewBox="0 0 12.2 12.2">
<g id="グループ_426" data-name="グループ 426" transform="translate(-577.9 -6554.9)">
    <path id="パス_10241" data-name="パス 10241" d="M6,0a6,6,0,1,0,6,6A6.008,6.008,0,0,0,6,0M6,11.23A5.23,5.23,0,1,1,11.23,6,5.236,5.236,0,0,1,6,11.23" transform="translate(578 6555)" stroke="#000" stroke-width="0.2"/>
    <path id="パス_10242" data-name="パス 10242" d="M41.065,20.428l-1.925-.474-.007-3.072a.522.522,0,1,0-1.043,0v3.641c0,.178.214.33.6.4l2.271.5c.3.035.541-.042.62-.409s-.175-.512-.51-.592" transform="translate(545.359 6540.956)" stroke="#000" stroke-width="0.2"/>
</g>
</svg>
);

const CalendarIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
<rect id="長方形_40457" data-name="長方形 40457" width="31" height="31" rx="5" fill="#005ead" />
<g id="グループ_27167" data-name="グループ 27167" transform="translate(-944 -851)">
  <path id="パス_10531" data-name="パス 10531" d="M15.649,27.8H4.925A1.168,1.168,0,0,1,3.753,26.66a1.154,1.154,0,0,1,1.172-1.142H15.649a1.141,1.141,0,0,1,1.172,1.142A1.155,1.155,0,0,1,15.649,27.8m0-6.369H4.925a1.153,1.153,0,0,1-1.172-1.141A1.167,1.167,0,0,1,4.925,19.15H15.649a1.154,1.154,0,0,1,1.172,1.144,1.14,1.14,0,0,1-1.172,1.141m0-6.346H4.925a1.167,1.167,0,0,1-1.172-1.142A1.154,1.154,0,0,1,4.925,12.8H15.649a1.141,1.141,0,0,1,1.172,1.142,1.154,1.154,0,0,1-1.172,1.142" transform="translate(952.179 846.196)" fill="#fff" />
  <path id="パス_10532" data-name="パス 10532" d="M2.385,27.8H1.171A1.168,1.168,0,0,1,0,26.66a1.154,1.154,0,0,1,1.171-1.142H2.385a1.14,1.14,0,0,1,1.17,1.142A1.154,1.154,0,0,1,2.385,27.8m0-6.369H1.171A1.153,1.153,0,0,1,0,20.294,1.167,1.167,0,0,1,1.171,19.15H2.385a1.153,1.153,0,0,1,1.17,1.144,1.139,1.139,0,0,1-1.17,1.141m0-6.346H1.171A1.167,1.167,0,0,1,0,13.946,1.154,1.154,0,0,1,1.171,12.8H2.385a1.14,1.14,0,0,1,1.17,1.142,1.152,1.152,0,0,1-1.17,1.142" transform="translate(950 846.196)" fill="#fff" />
</g>
</svg>);

/**
 * モバイル用予定一覧
 */
const ChosenScheduleList:ReactNode[] = []


async function fetchCalendar(apiUrl: string, date: Date) {

  const ym = format(date, "yyyy-MM")
  const res = await fetch(apiUrl + "&_calendar_year_month=" + ym)
  const result = await res.json()
  return result
}

const TimeField = (props:{target_date:string, time:string, cancels:CalendarEventCancel[]}) => {

  for(let cancel of props.cancels)
  {
    if(cancel.target_date === props.target_date && cancel.time === props.time)
    {
      return <span key={`${cancel.target_date}-${cancel.time}`} className="cancel">{props.time}</span>
    }
  }

  return <>{props.time}</>
}

const InnerContent = (props:{calEvent:CalendarEvent, target_date:string}) => {

  const {calEvent} = props 

  return  <div className={(calEvent.event_class || "") + " cal-event-content"}>
      {props.calEvent.terms.map((v, k)=>{
        return <div key={k} className={`cal-event-tag ${v.taxonomy}`}>{v.name}</div>
      })}
    <div className='cal-event-title'>
      <a href={calEvent.url} >{calEvent.title}</a>
    </div>
    <div className='label-begin-time'><ClockIcon /> 開催時間</div>
    {calEvent.time.map( (v, k)=>{
      return <div key={k} className='cal-event-time'><TimeField cancels={calEvent.cancel} target_date={props.target_date} time={v.time} /></div>
    } )}
  </div>
}

function isClosingDay(closingDays:string[], date:Date)
{
  const now = format(date, 'yyyy-MM-dd')
  if(closingDays.indexOf(now)>=0)
  {
    return true
  }
  return false
}


function App(props: { apiUrl: string }) {

  const [value, onChange] = useState(new Date());
  const ym = format(value, "yyyy-MM")
  const { isLoading, error, data } = useQuery('repoData' + ym, () => fetchCalendar(props.apiUrl, value))
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 601 })

  if (isLoading) return <>Loading...</>;
  if (error) return <>Error!</>;

  const closingDays = data.closing_days as string[]
  const spDailyClass:any = {}  

  const TileContent = (props: { date: Date, view: string }) => {
    if (props.view !== "month") return null;
    const now = format(props.date, 'yyyy-MM-dd')
    const Elements = [];
    const ScheduleList:ReactNode[] = []

    if(isClosingDay(closingDays, props.date))
    {
      let cdLabel = "休館日"
      if(!isDesktopOrLaptop)
      {
        cdLabel = "休"
      }
      return <div className='closingDay'>
          <span className="closingDayTxt">{cdLabel}</span>
        </div>
    }
    const cals:{[name:string]:boolean} = {}

    for (let calEvent of data.events as CalendarEvent[]) {

      if (calEvent.start_date <= now && calEvent.end_date >= now) {

        ScheduleList.push(<InnerContent target_date={now} calEvent={calEvent} />)
        
        if (!isDesktopOrLaptop) {

          // if(now  in cals){ 
          //   continue;
          // }
          // cals[now] = true
          if(Elements.length > 0)
          {
            Elements.pop()
          }else{
            spDailyClass[now] = ""
          }

          const taxName:string[] = []
          calEvent.terms.map((v)=>{
            taxName.push(v.taxonomy)
            spDailyClass[now] += " "+v.taxonomy
          })

             

          Elements.push(
            <>
              <div onClick={()=>{
                const nowLabel = format(parse(now, 'yyyy-MM-dd', new Date()), 'MM月dd日(E)', {locale:ja})
                ChosenScheduleList.splice(0)
                ChosenScheduleList.push(
                  <div className="chosen-schedule">
                    <div className="schedule-date">{nowLabel}</div>
                    {ScheduleList.map((v,k)=>(<Fragment key={k}>{v}</Fragment>))}
                  </div>
                )
              }}>
                  <a className="sp-event-content" href="#list-area-link">
                    <span className={spDailyClass[now]}><CalendarIcon /></span>
                  </a>
              </div>
            </>
          )
        } else {
          Elements.push(<InnerContent target_date={now} calEvent={calEvent} />)
        }
      }
    }

    return <div className='event-item'>
      {Elements.map((v, k) => (<Fragment key={k}>{v}</Fragment>))}
    </div>
  }

  const nextYearMonth = format(addYears(new Date(), 1), "yyyy-MM")
  let nextLabel:string|null = "›"
  if(ym === nextYearMonth)
  {
    nextLabel = null
  }


  return (
    <div className="App">
      <Calendar
        onChange={onChange}
        formatDay={ (locale, date) => date.getDate().toString() }
        minDetail="month"
        nextLabel={nextLabel}
        maxDetail="month"
        defaultView="month"
        onActiveStartDateChange={({ view, activeStartDate }) => {
          if (view !== "month") return;

          onChange(activeStartDate)
        }}
        tileContent={
          ({ date, view }) => (<TileContent date={date} view={view} />)
        }
        value={value}
        locale='ja-JP'
      />
      <a  id="list-area-link" ></a>
      <div id="list-area">
        {ChosenScheduleList.map((v,k)=>(<Fragment key={k}>{v}</Fragment>))}
      </div>
    </div>
  );
}

export default () => {
  const apiUrlInput = document.getElementById("api-url");
  if (!(apiUrlInput instanceof HTMLInputElement)) {
    return <></>;
  }


  return <QueryClientProvider client={queryClient}>
    <App apiUrl={apiUrlInput.value} />
  </QueryClientProvider>;
};
